export default function Footer() {
  const currentYear = new Date().getFullYear();

  const scrollToSection = (id: string) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <footer className="bg-gradient-to-br from-gray-900 to-gray-800 text-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-12 mb-12">
          <div>
            <img
              src="https://static.readdy.ai/image/8e1dd29798fcb43b2566dc879e04c9bd/e225e6f5cfb761e68abf456757fc7535.jpeg"
              alt="Logo Minha Casa Minha Vida"
              className="h-12 w-auto mb-6"
            />
            <p className="text-sm text-gray-400 leading-relaxed">
              Ajudamos milhares de famílias brasileiras a realizarem o sonho da casa própria através do programa Minha Casa Minha Vida.
            </p>
          </div>

          <div>
            <h3 className="text-base font-bold mb-4">Navegação</h3>
            <ul className="space-y-3">
              <li>
                <button
                  onClick={() => scrollToSection('calculadora')}
                  className="text-sm text-gray-400 hover:text-teal-400 transition-colors cursor-pointer whitespace-nowrap"
                >
                  Calculadora
                </button>
              </li>
              <li>
                <button
                  onClick={() => scrollToSection('beneficios')}
                  className="text-sm text-gray-400 hover:text-teal-400 transition-colors cursor-pointer whitespace-nowrap"
                >
                  Benefícios
                </button>
              </li>
              <li>
                <button
                  onClick={() => scrollToSection('garantia')}
                  className="text-sm text-gray-400 hover:text-teal-400 transition-colors cursor-pointer whitespace-nowrap"
                >
                  Garantia
                </button>
              </li>
              <li>
                <button
                  onClick={() => scrollToSection('formulario')}
                  className="text-sm text-gray-400 hover:text-teal-400 transition-colors cursor-pointer whitespace-nowrap"
                >
                  Contato
                </button>
              </li>
            </ul>
          </div>

          <div>
            <h3 className="text-base font-bold mb-4">Contato</h3>
            <ul className="space-y-3">
              <li className="flex items-start gap-3">
                <div className="w-5 h-5 flex items-center justify-center">
                  <i className="ri-phone-line text-base text-teal-400"></i>
                </div>
                <span className="text-sm text-gray-400">(00) 0000-0000</span>
              </li>
              <li className="flex items-start gap-3">
                <div className="w-5 h-5 flex items-center justify-center">
                  <i className="ri-mail-line text-base text-teal-400"></i>
                </div>
                <span className="text-sm text-gray-400">contato@exemplo.com.br</span>
              </li>
              <li className="flex items-start gap-3">
                <div className="w-5 h-5 flex items-center justify-center">
                  <i className="ri-time-line text-base text-teal-400"></i>
                </div>
                <span className="text-sm text-gray-400">Seg - Sex: 9h às 18h</span>
              </li>
            </ul>
          </div>

          <div>
            <h3 className="text-base font-bold mb-4">Redes Sociais</h3>
            <div className="flex gap-3">
              <a
                href="#"
                className="w-10 h-10 flex items-center justify-center bg-gray-800 hover:bg-teal-600 rounded-lg transition-colors cursor-pointer"
                aria-label="Facebook"
              >
                <i className="ri-facebook-fill text-lg"></i>
              </a>
              <a
                href="#"
                className="w-10 h-10 flex items-center justify-center bg-gray-800 hover:bg-teal-600 rounded-lg transition-colors cursor-pointer"
                aria-label="Instagram"
              >
                <i className="ri-instagram-line text-lg"></i>
              </a>
              <a
                href="#"
                className="w-10 h-10 flex items-center justify-center bg-gray-800 hover:bg-teal-600 rounded-lg transition-colors cursor-pointer"
                aria-label="WhatsApp"
              >
                <i className="ri-whatsapp-line text-lg"></i>
              </a>
              <a
                href="#"
                className="w-10 h-10 flex items-center justify-center bg-gray-800 hover:bg-teal-600 rounded-lg transition-colors cursor-pointer"
                aria-label="LinkedIn"
              >
                <i className="ri-linkedin-fill text-lg"></i>
              </a>
            </div>
          </div>
        </div>

        <div className="border-t border-gray-700 pt-8">
          <div className="flex flex-col md:flex-row justify-between items-center gap-4">
            <p className="text-sm text-gray-400">
              © {currentYear} Minha Casa Minha Vida. Todos os direitos reservados.
            </p>
            <a
              href="https://readdy.ai/?ref=logo"
              target="_blank"
              rel="noopener noreferrer"
              className="text-sm text-gray-400 hover:text-teal-400 transition-colors cursor-pointer whitespace-nowrap"
            >
              Powered by Readdy
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}
